export default "__VITE_ASSET__7jKR_AAf__"